export default __webpack_public_path__ + "static/map-1dd4b3ea15b212fae450f389e72b1864.mp4";